import { useState } from "react";
import Link from "next/link";
import { motion } from "framer-motion";

const ServicesHero = () => {
    return (
        <section className="relative min-h-screen flex items-center justify-center bg-[#FAFAFA] py-20 lg:py-28 2xl:py-38 overflow-hidden">
            
            {/* Ultra-Wide Luxury Background Glows */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] 2xl:w-[1200px] h-[400px] 2xl:h-[600px] bg-[#B8893A]/5 rounded-full blur-[160px] pointer-events-none" />
            <div className="absolute -bottom-20 left-1/4 w-[400px] h-[400px] bg-amber-500/[0.02] rounded-full blur-[120px] pointer-events-none" />

            {/* Expanded container width up to 7xl for 2200px displays */}
            <div className="max-w-4xl xl:max-w-6xl 2xl:max-w-7xl mx-auto w-full px-6 sm:px-12 relative z-10 text-center flex flex-col items-center">
                
                {/* Premium Mini Tag with Enhanced Scaling */}
                <motion.div
                    initial={{ opacity: 0, y: -15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-[#B8893A]/20 bg-[#B8893A]/5 mb-8 2xl:mb-12 backdrop-blur-sm shadow-sm"
                >
                    <span className="w-2 h-2 rounded-full bg-[#B8893A] animate-pulse" />
                    <span className="text-[10px] sm:text-xs 2xl:text-sm font-bold text-[#B8893A] uppercase tracking-[0.2em]">
                        Your Gateway to UAE Success
                    </span>
                </motion.div>

                {/* Pop-out Heading with Premium Font Scaling & subtle text shadow */}
                <motion.h1 
                    initial={{ opacity: 0, y: 25 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, ease: "easeOut" }}
                    className="text-4xl sm:text-5xl md:text-6xl xl:text-7xl 2xl:text-8xl font-black text-[#000000] tracking-tight leading-[1.0] mb-8 xl:mb-10 max-w-5xl selection:bg-amber-100"
                    style={{
                        textShadow: "0 2px 10px rgba(0,0,0,0.02)"
                    }}
                >
                    Professional Solutions <br className="hidden sm:block" />
                    <span className="bg-gradient-to-r from-[#B8893A] via-[#d6a754] to-[#B8893A] bg-clip-text text-transparent filter drop-shadow-[0_2px_5px_rgba(184,137,58,0.15)]">
                        For Your Business
                    </span>
                </motion.h1>

                {/* Stars Ratings - Scaled up for large viewports */}
              

                {/* Subtext - Balanced max-width so text does not stretch awkwardly */}
                <motion.p 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.9, delay: 0.2 }}
                    className="text-gray-500 text-base sm:text-lg md:text-xl xl:text-2xl max-w-2xl xl:max-w-4xl font-light leading-relaxed mb-6 xl:mb-10"
                >
                    We provide comprehensive business setup, visa processing, and corporate support services tailored to help you thrive in the United Arab Emirates.
                </motion.p>

                {/* CTA Button - Bold, solid and scaled for large screens */}
                <motion.div 
                    initial={{ opacity: 0, scale: 0.97 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.6, delay: 0.4 }}
                    className="w-full sm:w-auto"
                >
                    <a
            href="https://wa.me/923001234567"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-10 py-4 text-white rounded-xl font-bold text-sm tracking-wide shadow-lg shadow-amber-950/10 transition-all duration-300 hover:bg-[#a3762f] hover:scale-[1.02] active:scale-[0.98]"
            style={{ background: "#B8893A" }}
          >
            Get a Free Consultation
          </a>
                </motion.div>

                {/* Centered Metrics - Spreads wider gracefully on 2200px */}
                <motion.div 
                    initial={{ opacity: 0, y: 40 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    className="grid grid-cols-2 gap-16 sm:gap-32 xl:gap-48 border-t border-gray-200/80 w-full max-w-2xl xl:max-w-4xl mt-24 xl:mt-32 pt-12 xl:pt-16"
                >
                    <div className="group">
                        <div className="text-3xl sm:text-4xl xl:text-5xl 2xl:text-6xl font-black text-[#B8893A] tracking-tight transition-transform duration-300 group-hover:scale-105">5000+</div>
                        <div className="text-[10px] sm:text-xs xl:text-sm font-bold text-gray-400 uppercase tracking-widest mt-2">Clients Served</div>
                    </div>
                    <div className="group">
                        <div className="text-3xl sm:text-4xl xl:text-5xl 2xl:text-6xl font-black text-[#B8893A] tracking-tight transition-transform duration-300 group-hover:scale-105">100%</div>
                        <div className="text-[10px] sm:text-xs xl:text-sm font-bold text-gray-400 uppercase tracking-widest mt-2">Compliance Rate</div>
                    </div>
                </motion.div>

            </div>
        </section>
    );
};

export default ServicesHero;